<div class='Reports'>
  <div class='d-flex flex-column flex-sm-row justify-content-start'>
    <h3>Reports</h3>
  </div>

  <div class='d-flex flex-column flex-sm-row justify-content-center'>
    <div class='d-flex flex-column flex-sm-row justify-content-center justify-content-sm-end align-items-center'>
      <app-button *ngIf='currentUsersSelection.length' [Click]='downloadButtonProperties.onClick'
                  [color]='downloadButtonProperties.color'
                  [disabled]='reportDownloadInProgress'
                  [size]='downloadButtonProperties.size' [text]='downloadButtonProperties.text'></app-button>
      <app-button *ngIf='currentUsersSelection.length' [Click]='downloadCloserButtonProperties.onClick'
                  [color]='downloadCloserButtonProperties.color'
                  [disabled]='reportDownloadInProgress'
                  [size]='downloadCloserButtonProperties.size'
                  [text]='downloadCloserButtonProperties.text'
                  class='ms-0 ms-sm-5'></app-button>
      <app-button [Click]='filterButtonProperties.onClick' [color]='filterButtonProperties.color'
                  [disabled]='reportDownloadInProgress'
                  [size]='filterButtonProperties.size' [text]='filterButtonProperties.text'
                  class='ms-0 ms-sm-5'></app-button>
    </div>
  </div>
  <div *ngIf='reportDownloadInProgress' class='row mt-5'>
    <div class='col col-12 text-center alert alert-warning'>
      <p *ngIf='!showReportWarning; else notInProgress' class='mb-0'>You have report to be downloaded first, before
        generating a new one</p>
      <ng-template #notInProgress>
        <p>Your report is being downloading. Please, wait!</p>
      </ng-template>
    </div>
  </div>
  <div class='Reports__data mt-5'>
    <mat-tab-group #tabGroup (selectedTabChange)='onTabChange($event)' mat-align-tabs='center'>
      <mat-tab label='Contact Report'>
        <div *ngIf='!filterApplied; else usersTable' class='alert alert-info'>
          <p>Please, filter users first</p>
        </div>
        <ng-template #usersTable>
          <app-table [columns]='usersTableColumns' [dataSourceParams]='usersTableDatasourceParams'
                     [dataSource]='usersTableDataSource'></app-table>
        </ng-template>
      </mat-tab>
      <mat-tab label='Closer Report'>
        <div *ngIf='!filterApplied; else closerTable' class='alert alert-info'>
          <p>Please, filter users first</p>
        </div>
        <ng-template #closerTable>
          <app-table *ngIf='loadClosers' [columns]='closerTableColumns' [dataSourceParams]='closerTableDataSourceParams'
                     [dataSource]='closerTableDataSource'></app-table>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
